import React from 'react';
import { motion } from 'framer-motion';
export const About = () => {
  return <section className="bg-background" data-id="element-14">
      <div className="flex flex-col md:flex-row min-h-[80vh]" data-id="element-15">
        {/* Left: Image with Ken Burns */}
        <div className="w-full md:w-1/2 relative overflow-hidden h-[50vh] md:h-auto" data-id="element-16">
          <div className="absolute inset-0 bg-cover bg-center animate-ken-burns origin-center" style={{
          backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8wQ1uy5Sdy1edMjs48WCoy/mejora_la_foto_a_8k_202605062043.jpg)'
        }} data-id="element-17" />
          <div className="absolute inset-0 bg-black/20" data-id="element-18" />
        </div>

        {/* Right: Content */}
        <div className="w-full md:w-1/2 bg-gradient-to-br from-[#1a1a1a] to-background p-10 md:p-20 flex flex-col justify-center" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-20">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-21">
              Hola, soy Joha
            </h2>

            <div className="space-y-6 text-lg text-gray-300 leading-relaxed mb-12" data-id="element-22">
              <p data-id="element-23">Trabajo en redes sociales y ventas desde hace años.</p>
              <p data-id="element-24">Y aprendí algo que la mayoría ignora:</p>
              <p className="text-2xl font-serif font-bold text-primary my-8 border-l-4 border-primary pl-6 py-2" data-id="element-25">
                Una web no es decoración.
                <br data-id="element-26" />
                Es tu vendedor número uno.
              </p>
              <p data-id="element-27">
                Por eso cada página que diseño está pensada para convertir
                visitas en clientes reales.
              </p>
            </div>

            <ul className="space-y-4 text-white font-medium" data-id="element-28">
              {[{
              icon: '⚡',
              text: 'Entrega en 48/72 hs'
            }, {
              icon: '🎯',
              text: '100% personalizada'
            }, {
              icon: '📱',
              text: 'Optimizada mobile'
            }, {
              icon: '🇦🇷',
              text: 'Para Argentina'
            }].map((item, i) => <motion.li key={i} className="flex items-center gap-4 text-lg" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5 + i * 0.1,
              duration: 0.5
            }} data-id="element-29">
                  <span className="text-2xl" data-id="element-30">{item.icon}</span>
                  {item.text}
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};